export default __webpack_public_path__ + "static/media/businessAnalystTheme.807faa65.png";